import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/**
 * AuthCallback exchanges the one-time `session_id` from the URL fragment
 * for a persistent session cookie, then routes into the app.
 *
 * Rendered synchronously (during render, NOT useEffect) whenever the URL
 * hash contains `session_id=`. See App.js AppRouter.
 */
export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    api.post("/auth/session", { session_id: sessionId })
      .then(({ data }) => {
        setUser(data);
        // Clear the fragment so refreshing the page won't retry the (now stale) session_id
        window.history.replaceState({}, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: data } });
      })
      .catch(() => {
        navigate("/login", { replace: true });
      });
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#FAFAF9] flex items-center justify-center">
      <span className="font-heading text-2xl text-stone-300 animate-pulse">Julia AI</span>
    </div>
  );
}
